module.exports = __webpack_public_path__ + "static/app-icon-d2adba751aec03965b7c8661e744c54c.png";